import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { UserSettingsStateService } from '@services/user-settings.state.service';
import { defaultTheme, THEMES } from '@shared/config/themes';
import { ORNavigationService } from '@shared/services';
import { FileUrlService } from '@shared/services/file-url.service';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BrandingFileRole, FileEntity } from '@shared/models/file.model';

@Component({
  selector: 'od-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  imports: [AsyncPipe],
})
export class LogoComponent {
  public headerUrl$: Observable<string>;

  constructor(
    private userSettingsStateService: UserSettingsStateService,
    private navigationService: ORNavigationService,
    private fileUrlService: FileUrlService
  ) {
    this.headerUrl$ = this.userSettingsStateService.theme$.pipe(
      map(userTheme => {
        const theme = LocalStorageService.isLoggedIn()
          ? userTheme
          : defaultTheme;
        return this.fileUrlService.getFileUrl({
          entity: FileEntity.BRANDING,
          role: BrandingFileRole.HEADER,
          branding: theme || THEMES.dark,
          content: true,
        });
      })
    );
  }

  goHome(): void {
    this.navigationService.goHome();
  }
}
